import React from 'react';

import { CAR_PRIZE_DRAW_ROUTE } from 'Utilities/routing';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import { useMetaTags } from 'Hooks/misc/useMetaTags';

import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';
import Status404 from '../../../error/404';
import { useCarPrizeDrawExperiment } from '../../../experiments/useCarPrizeDrawExperiment/useCarPrizeDrawExperiment';
import FastlaneHero from '../../../fastlane/home/Hero/Hero';
import { ExpandableContentWrapper } from '../../Components/ExpandableContentWrapper/ExpandableContentWrapper';

import { EligibilityAndEntryCriteria } from './EligibilityAndEntryCriteria/EligibilityAndEntryCriteria';
import { HowToEnter } from './HowToEnter/HowToEnter';
import { PrizeSection } from './PrizeSection/PrizeSection';
import { QuotesSection } from './QuotesSection/QuotesSection';
import Texts from './CarPrizeDraw.texts.json';

import styles from './CarPrizeDraw.module.scss';

const CarPrizeDrawContent: React.FC = () => {
  useMetaTags({
    description: Texts.meta.description,
    title: Texts.meta.title,
  }, CAR_PRIZE_DRAW_ROUTE);

  return (
    <div className={styles.component}>
      <div className={styles.heroSection}>
        <FastlaneHero
          isHideBreadcrumb={false}
          subTitle={Texts.hero.description}
          title={Texts.hero.title}
        />
        <RoundedSection withBottomLedge withTopLedge theme="off-white">
          <PrizeSection />
        </RoundedSection>
      </div>
      <RoundedSection withBottomLedge withTopLedge>
        <ComponentContent maxWidth={CONTENT_SIZES.container}>
          <HowToEnter/>
        </ComponentContent>
      </RoundedSection>
      <QuotesSection/>
      <EligibilityAndEntryCriteria/>
      <ExpandableContentWrapper
        faq={Texts.faq.items}
        faqTitle={Texts.faq.title}
      />
    </div>
  );
};

export const CarPrizeDraw: React.FC = () => {
  const { isCarPrizeDrawEnabled } = useCarPrizeDrawExperiment();

  if (!isCarPrizeDrawEnabled) {
    return <Status404 />;
  }

  return <CarPrizeDrawContent />;
};

export default CarPrizeDraw;
